type OwnProps = {
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function NotificationAlerts({ children }: Props) {
  return (
    <div id="notifications" className="notification-alerts">
      {children}
    </div>
  );
}

NotificationAlerts.defaultProps = defaultProps;

export default NotificationAlerts;
